import { Injectable } from "@angular/core";
import jsPDF from "jspdf";
import "jspdf-autotable";
import html2canvas from "html2canvas";

@Injectable({
  providedIn: "root",
})
export class PrintPDFService {
  showLoader = false;
  testPlanPerPage: number = 10;
  brkCountPC: number = 22;
  brkCountWC: number = 20;
  albums;
  smthAuditTrails;
  commentValueData;
  testPlanListItems;
  testSlipDetails;
  PDF;
  constructor() {}

  async exportToPDF(a, s, c, t, testSlipDetails) {
    this.PDF = new jsPDF("p", "mm", "a4", true);
    this.albums = a;
    this.smthAuditTrails = s;
    this.commentValueData = c;
    this.testPlanListItems = t;
    this.testSlipDetails = testSlipDetails;
    window.scroll(0, 0);
    this.showLoader = true;
    let pdfDataFull = <HTMLCanvasElement>document.getElementById("fullData");

    let testSlipId = <HTMLCanvasElement>document.getElementById("testSlipId");
    let addComent = <HTMLCanvasElement>document.getElementById("addComments");
    let rightPanel = <HTMLCanvasElement>(
      document.getElementById("right-sidepanel")
    );
    let leftPanel = <HTMLCanvasElement>(
      document.getElementById("left-sidepanel")
    );
    let imagePanel = <HTMLCanvasElement>(
      document.getElementById("testPlanPhotostab")
    );
    // let digitalWirePanel = <HTMLCanvasElement>document.getElementById('digitalWireCounttab');
    let testExecutionPanel = <HTMLCanvasElement>(
      document.getElementById("test-executiontabs")
    );
    let testSlipStatustab = <HTMLCanvasElement>(
      document.getElementById("testSlipStatustab")
    );
    let testSlipDetailstab = <HTMLCanvasElement>(
      document.getElementById("testSlipDetailstab")
    );
    let testPlanCommenttab = <HTMLCanvasElement>(
      document.getElementById("testPlanCommenttab")
    );
    let buttonBox = <HTMLCanvasElement>document.getElementById("buttonBox");

    if (buttonBox !== null) {
      buttonBox.hidden = true;
    }
    document.querySelectorAll(".comments-box").forEach((x) => {
      x.classList.add("shadow-disable");
    });
    if (this.albums.length == 0) {
      imagePanel.hidden = true;
    }

    // pdfDataFull.style.zoom = '100%';
    if (addComent) {
      addComent.hidden = true;
    }
    rightPanel.hidden = true;
    if (this.smthAuditTrails.length > 5) {
      imagePanel.hidden = true;
      testSlipDetailstab.hidden = true;
    }
    testSlipId.style.display = "block";
    leftPanel.classList.remove("col-lg-6");
    leftPanel.classList.add("col");
    testPlanCommenttab.hidden = true;

    window.scroll(0, 0);
    this.PDF = (await this.createPDFPageByElementID(
      "left-sidepanel",
      this.PDF,
      true
    )) as jsPDF;
    testSlipId.style.display = "none";
    if (this.smthAuditTrails.length > 5) {
      testSlipStatustab.hidden = true;

      if (this.albums.length !== 0) {
        imagePanel.hidden = false;
      }
      testSlipDetailstab.hidden = false;
      window.scroll(0, 0);
      this.PDF = (await this.createPDFPageByElementID(
        "left-sidepanel",
        this.PDF,
        false
      )) as jsPDF;
    }
    if (this.commentValueData && this.commentValueData.length > 0) {
      testPlanCommenttab.hidden = false;
      imagePanel.hidden = true;
      testSlipDetailstab.hidden = true;
      testSlipStatustab.hidden = true;
      window.scroll(0, 0);
      this.PDF = (await this.createPDFPageByElementID(
        "left-sidepanel",
        this.PDF,
        false
      )) as jsPDF;
    }
    leftPanel.classList.remove("col");
    leftPanel.classList.add("col-lg-6");
    rightPanel.hidden = false;
    leftPanel.hidden = true;
    let panelistcount = 0;
    for (const items of this.testPlanListItems) {
      // let innerpanels = <HTMLCanvasElement>document.getElementById('testPlanExecutiontab_'+panelistcount);
      let nestedpanelistcount = 0;
      let present_count = 0;
      for (var i = 0; i < this.testPlanListItems.length; i++) {
        document
          .getElementsByClassName("hiddentext")
          [i].removeAttribute("hidden");
      }
      for (const inneritems of this.testPlanListItems) {
        let nestedinnerpanels = <HTMLCanvasElement>(
          document.getElementById("testPlanExecutiontab_" + nestedpanelistcount)
        );
        if (
          "testPlanExecutiontab_" + nestedpanelistcount !==
          "testPlanExecutiontab_" + panelistcount
        ) {
          nestedinnerpanels.hidden = true;
        } else present_count = nestedpanelistcount;
        nestedpanelistcount++;
      }

      let digitalWireCounttab = <HTMLCanvasElement>(
        document.getElementById("digitalWireCounttab_" + present_count)
      );
      if (digitalWireCounttab != null) {
        digitalWireCounttab.hidden = true;
      }

      let digitalPermutationChartTab = <HTMLCanvasElement>(
        document.getElementById("digitalPermutationChartTab_" + present_count)
      );
      if (digitalPermutationChartTab != null) {
        digitalPermutationChartTab.hidden = true;
      }
      let loopCount = Math.ceil(
        items.smthTestPlans.length / this.testPlanPerPage
      );
      let serialNoBody = <HTMLCanvasElement>(
        document.getElementById("serialNoBody_" + present_count)
      );
      for (let i = 1; i <= loopCount; i++) {
        if (i > 1) {
          if (serialNoBody !== null) serialNoBody.hidden = true;
        }

        document
          .querySelectorAll(".slipDetails_class_" + present_count)
          .forEach((x) => {
            x.classList.add("hiddenItems");
          });
        for (
          let j = this.testPlanPerPage * (i - 1);
          j < this.testPlanPerPage * i && j < items.smthTestPlans.length;
          j++
        ) {
          let innerslipDetails = <HTMLCanvasElement>(
            document.getElementById(
              "innerslipDetails_" + present_count + "_" + j
            )
          );
          if (innerslipDetails != null) {
            innerslipDetails.classList.remove("hiddenItems");
          }
        }
        rightPanel.classList.remove("col-lg-6");
        rightPanel.classList.add("col");
        window.scroll(0, 0);
        this.PDF = (await this.createPDFPageByElementID(
          "right-sidepanel",
          this.PDF,
          false
        )) as jsPDF;
      }
      if (serialNoBody !== null) serialNoBody.hidden = false;
      document
        .querySelectorAll(".slipDetails_class_" + present_count)
        .forEach((x) => {
          x.classList.remove("hiddenItems");
        });

      /*code need digitalWireCounttab in seperate page */
      if (digitalWireCounttab != null) {
        digitalWireCounttab.hidden = false;
        let slipDetails = <HTMLCanvasElement>(
          document.getElementById("slipDetails_" + present_count)
        );
        if (serialNoBody != null) {
          serialNoBody.hidden = true;
        }
        if (slipDetails != null) {
          slipDetails.hidden = true;
        }

        const wirecounts = digitalWireCounttab.querySelectorAll('.wireCountData');
        let wc_tot = wirecounts?.length;


        for (let x = 0; x < wc_tot; x++) {
          document.querySelectorAll(".wcForm").forEach((x) => {
            x.classList.add("hiddenItems");
          });
          if (
            !this.testSlipDetails.smthTestSlipWireCountDTO[x]
              .fileData
          ) {
            let before = await document.getElementById(
              "wireCountHead_" + present_count + "_" + x + "_" + 1
            );
            let after = await document.getElementById(
              "wireCountHead_" + present_count + "_" + x + "_" + 2
            );
            let fd = await document.getElementById(
              "wireCountHead_" + present_count + "_" + x + "_" + 3
            );
            fd?.classList.remove("hiddenItems");
            window.scroll(0, 0);
            this.PDF = (await this.createPDFPageByElementID(
              "right-sidepanel",
              this.PDF,
              false
            )) as jsPDF;
            fd?.classList.add("hiddenItems");
            if (before !== null) {
              before?.classList.remove("hiddenItems");
              let aft = await this.wc_pr(
                present_count,
                x,
                serialNoBody,
                slipDetails,
                "1"
              );
              before?.classList.add("hiddenItems");
            }
            if (after !== null) {
              after?.classList.remove("hiddenItems");
              let aft = await this.wc_pr(
                present_count,
                x,
                serialNoBody,
                slipDetails,
                "2"
              );
            }
          } else {
            const img = await document.getElementById(
              "wireCountFile_" + present_count + "_" + x
            );
            img?.classList.remove("hiddenItems");
            window.scroll(0, 0);
            this.PDF = (await this.createPDFPageByElementID(
              "right-sidepanel",
              this.PDF,
              false
            )) as jsPDF;
            img.classList.add("hiddenItems");
          }
        }

        document.querySelectorAll(".wcForm").forEach((x) => {
          x.classList.remove("hiddenItems");
        });
        if (serialNoBody != null) {
          serialNoBody.hidden = false;
        }
        if (slipDetails != null) {
          slipDetails.hidden = false;
        }
      }
      /*code digitalPermutationChartTab in seperate page*/
      if (digitalPermutationChartTab != null) {
        digitalPermutationChartTab.hidden = false;
        let slipDetails = <HTMLCanvasElement>(
          document.getElementById("slipDetails_" + present_count)
        );
        if (serialNoBody != null) {
          serialNoBody.hidden = true;
        }
        if (slipDetails != null) {
          slipDetails.hidden = true;
        }
        if (serialNoBody != null || slipDetails != null) {
          let tot = document.getElementById("dpc_" + present_count).children
            .length;
          let loopCount = Math.ceil(tot / this.brkCountPC);
          if (tot >= this.brkCountPC + 2) {
            for (let i = 1; i <= loopCount; i++) {
              document
                .querySelectorAll(".slipDetailsPC_" + present_count)
                .forEach((x) => {
                  x.classList.add("hiddenItems");
                });
              for (
                let j = this.brkCountPC * (i - 1);
                j < this.brkCountPC * i && j < tot;
                j++
              ) {
                let innerslipDetails = <HTMLCanvasElement>(
                  document.getElementById(
                    "pcDetails_" + present_count + "_" + j
                  )
                );
                if (innerslipDetails != null) {
                  innerslipDetails.classList.remove("hiddenItems");
                }
              }
              window.scroll(0, 0);
              this.PDF = (await this.createPDFPageByElementID(
                "right-sidepanel",
                this.PDF,
                false
              )) as jsPDF;
            }
          } else {
            window.scroll(0, 0);
            this.PDF = (await this.createPDFPageByElementID(
              "right-sidepanel",
              this.PDF,
              false
            )) as jsPDF;
          }
        }
        if (serialNoBody != null) {
          serialNoBody.hidden = false;
        }
        if (slipDetails != null) {
          slipDetails.hidden = false;
        }
      }

      panelistcount++;
      let finalCount = 0;
      for (const inneritems of this.testPlanListItems) {
        let finalnestedinnerpanels = <HTMLCanvasElement>(
          document.getElementById("testPlanExecutiontab_" + finalCount)
        );
        finalnestedinnerpanels.hidden = false;
        finalCount++;
      }
    }
    document.querySelectorAll(".comments-box").forEach((x) => {
      x.classList.remove("shadow-disable");
    });
    leftPanel.hidden = false;

    if (addComent) {
      addComent.hidden = false;
    }

    testSlipStatustab.hidden = false;
    imagePanel.hidden = false;
    testSlipDetailstab.hidden = false;
    testPlanCommenttab.hidden = false;
    testExecutionPanel.hidden = false;
    if (buttonBox !== null) {
      buttonBox.hidden = false;
    }
    for (var i = 0; i < this.testPlanListItems.length; i++) {
      document
        .getElementsByClassName("hiddentext")
        [i].setAttribute("hidden", "true");
    }

    rightPanel.classList.remove("col");
    rightPanel.classList.add("col-lg-6");
    this.PDF.save("testSlipDetails.pdf");
    this.albums = "";
    this.smthAuditTrails = "";
    this.commentValueData = "";
    this.testPlanListItems = "";
    this.testSlipDetails = "";
    this.PDF = "";
    this.showLoader = false;
  }

  async createPDFPageByElementID(elementName, PDF, isFirstPage) {
    let testSlipElement = <HTMLCanvasElement>(
      document.getElementById(elementName)
    );
    const canvas = await html2canvas(testSlipElement);
    let position = 0;
    const imgProps = this.PDF.getImageProperties(canvas);
    const pdfWidth = this.PDF.internal.pageSize.getWidth();
    let pageHeight = this.PDF.internal.pageSize.getHeight() - 30;
    let pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    if (!isFirstPage) {
      this.PDF.addPage();
    }
    const FILEURI = canvas.toDataURL("image/png", 1.0);
    this.PDF.addImage(FILEURI, "PNG", 0, position, pdfWidth, pdfHeight);
    let heightLeft = pdfHeight;
    heightLeft -= pageHeight;
    while (heightLeft >= 0) {
      position = position - pageHeight;
      this.PDF.addPage();
      this.PDF.addImage(FILEURI, "PNG", 0, position, pdfWidth, pdfHeight);
      heightLeft = heightLeft - pageHeight;
    }
    return this.PDF;
  }

  async wc_pr(present_count, x, serialNoBody, slipDetails, A_OR_B) {
    document
      .querySelectorAll(".wireCountData")
      .forEach((x) => x.classList.add("hiddenItems"));
    let rc = document.getElementById("wireCount_" + present_count + "_" + x);
    rc.classList.remove("hiddenItems");
    if (serialNoBody != null || slipDetails != null) {
      let tot = document.getElementById(
        "dwc_" + present_count + "_" + x + "_" + A_OR_B
      ).children.length;
      let loopCount = Math.ceil(tot / this.brkCountWC);
      if (tot >= this.brkCountWC + 2) {
        for (let i = 1; i <= loopCount; i++) {
          document
            .querySelectorAll(
              ".slipDetailsWC_" + present_count + "_" + x + "_" + A_OR_B
            )
            .forEach((x) => {
              x.classList.add("hiddenItems");
            });
          for (
            let j = this.brkCountWC * (i - 1);
            j < this.brkCountWC * i && j < tot;
            j++
          ) {
            let innerslipDetails = <HTMLCanvasElement>(
              document.getElementById(
                "wcDetails_" + present_count + "_" + x + "_" + A_OR_B + "_" + j
              )
            );
            if (innerslipDetails != null) {
              innerslipDetails.classList.remove("hiddenItems");
            }
          }
          window.scroll(0, 0);
          this.PDF = (await this.createPDFPageByElementID(
            "right-sidepanel",
            this.PDF,
            false
          )) as jsPDF;
          document
            .querySelectorAll(
              ".slipDetailsWC_" + present_count + "_" + x + "_" + A_OR_B
            )
            .forEach((x) => {
              x.classList.remove("hiddenItems");
            });
        }
      } else {
        window.scroll(0, 0);
        this.PDF = (await this.createPDFPageByElementID(
          "right-sidepanel",
          this.PDF,
          false
        )) as jsPDF;
      }
    }
    document
      .querySelectorAll(".wireCountData")
      .forEach((x) => x.classList.remove("hiddenItems"));
    return console.log("d");
  }
}
